import React from 'react';
import styled from 'styled-components';
import { MobileScreen } from '../styles/ConstantMediaQuery';
import ColorConstants from '../../constants/ColorConstants';

interface InsightHeaderProps {
    title?: string;
    subtitle?: string;
    dataAppcuesId?: string;
}

const InsightHeader = ({ title, subtitle, dataAppcuesId }: InsightHeaderProps) => (
    <Wrapper data-appcues-id={dataAppcuesId}>
        {title && (
            <InsightTitle marginTop="20px">
                {title}
            </InsightTitle>
        )}

        {subtitle && (
            <InsightSubtitle>
                {subtitle}
            </InsightSubtitle>
        )}
    </Wrapper>
);

InsightHeader.defaultProps = {
    subtitle: null,
};

const InsightSubtitle = styled.p`
    color: ${ColorConstants['regal-blue']};
    font-size: 15px;
    font-weight: 400;
    margin-bottom: 30px;
    align-items: center;
    justify-content: space-between;

    @media ${MobileScreen} {
        margin-bottom: 0;
    }
`;

const InsightTitle = styled.h2`
    color: ${ColorConstants['regal-blue']};
    font-size: 24px;
    font-weight: 500;
    margin-top: ${({ marginTop }) => marginTop};

    @media ${MobileScreen} {
        margin: 0;
    }
`;

const Wrapper = styled.div`
    @media ${MobileScreen} {
        margin-bottom: 20px;
    }
`;

export default InsightHeader;
